<template>
  <CContainer fluid>
    <h3>Recepci&oacute;n de Documentos Electr&oacute;nicos</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:" 
              addLabelClasses="text-muted font-weight-bold" 
              :value.sync="searchWord"
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="3" sm="3">
            <CSelect 
              label="Eventos" 
              addLabelClasses="text-muted font-weight-bold" 
              :options="listEventStatus"
              :value.sync="eventStatusSelected" 
              @change="getData(1)" />
          </CCol>
          <CCol col="3" sm="3">
            <CButton 
              color="dark" 
              variant="outline" 
              class="mt-4" 
              @click="showPanel=true">
              <i class="bi bi-file-earmark-excel h5 mr-2"></i>
              <span>Importar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable 
          hover 
          class="table-hover-icons"
          :responsive=true
          :fields="fields" 
          :items="data_documents" 
          :items-per-page="itemsPerPage">
          <template #empresa="{item}">
            <td>
              <div>
                {{ item.razon_Social }}
              </div>
              <div>
                <h5>
                  {{ item.identificacion }}
                </h5>
              </div>
              <div>
                <small class="text-muted">{{ moment(item.fecha_Creacion).format("DD/MM/YYYY - hh:mm:ss") }}</small>
              </div>
            </td>
          </template>
          <template #documento="{item}">
            <td>
              <div>
                <i class="bi bi-bag-check text-success mr-1" v-if="item.documento_id"></i>
                <i class="bi bi-bag-x text-danger mr-1" v-else></i>
                <strong>
                  {{ item.documento }}
                </strong>
              </div>
              <div>
                <span>{{ item.prefijo }}</span>
                <span v-if="item.prefijo"> - </span>
                <span>{{ item.numero }}</span>
              </div>
              <div>
                <CBadge :color="getBadgeColor(item.estado_Evento)">
                  <span>{{ eventStatus[item.estado_Evento] ? eventStatus[item.estado_Evento] : "Sin Evento" }}</span>
                </CBadge>
              </div>
            </td>
          </template>
          <template #fechas="{item}">
            <td>
              <div>
                <i class="bi bi-calendar3 text-success mr-1"></i>
                <span>
                  {{ moment(item.fecha_Emision).format("DD/MM/YYYY") }}
                </span>
              </div>
              <div v-if="item.fecha_Vencimiento !== null">
                <i class="bi bi-calendar3 text-danger mr-1"></i>
                <span>
                  {{ moment(item.fecha_Vencimiento).format("DD/MM/YYYY") }}
                </span>
              </div>
            </td>
          </template>
          <template #valores="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <span>${{ formatter.format(item.valor_Mercancia, 2) }}</span>
              </div>
              <div class="d-flex justify-content-end">
                <span>${{ formatter.format(item.valor_Impuestos, 2) }}</span>
              </div>
              <div class="d-flex justify-content-end">
                <strong>${{ formatter.format(item.valor_Total, 2) }}</strong>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td class="d-flex">
              <div class="hover-actions">
                <a href="#"
                  @click="(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    showPanelItemsDocument = true;
                    electronicDocumentId = item.id_DocumentoDIAN;
                    updateComponent += 1;
                  }">
                  <i class="bi bi-journal-text text-info h4 mr-2 hover-icon"></i>
                </a>
                <a href="#"
                  @click="(e) => downloadAttachment(e, item.path_DocumentoPDF)">
                  <i class="bi bi-file-earmark-pdf text-danger h4 mr-2 hover-icon"></i>
                </a>
                <a href="#" v-if="!item.documento_id"
                  @click="(e) => tryConvertElectronicDocument(e, item.id_DocumentoDIAN)">
                  <i class="bi bi-bag-check text-dark h4 mr-2 hover-icon"></i>
                </a>
              </div>
              <a href="#" v-if="item.estado_Evento === null" 
                class="mr-2" 
                v-c-tooltip="'Acuse de recibo'"
                @click="(e) => sendEvent(e, item.id_DocumentoDIAN, '030')">
                <i class="bi bi-file-earmark-break h4"></i>
              </a>
              <a href="#" v-if="item.estado_Evento === '030'" 
                class="mr-2" 
                v-c-tooltip="'Recibo del bien o servicio'"
                @click="(event) => sendEvent(event, item.id_DocumentoDIAN, '032')">
                <i class="bi bi-file-earmark-plus text-warning h4"></i>
              </a>
              <a href="#" v-if="item.estado_Evento === '032'" 
                class="mr-2" 
                v-c-tooltip="'Reclamo en documento.'"
                @click="(event) => sendEvent(event, item.id_DocumentoDIAN, '031')">
                <i class="bi bi-file-earmark-x text-danger h4"></i>
              </a>
              <a href="#" v-if="item.estado_Evento === '032'"
                class="mr-2" 
                v-c-tooltip="'Aceptacion Expresa'"
                @click="(event) => sendEvent(event, item.id_DocumentoDIAN, '033')">
                <i class="bi bi-file-earmark-check h4 text-success"></i>
              </a>
            </td>
          </template>
        </CDataTable>
        <CPagination 
          size="sm" 
          class="d-flex justify-content-center" 
          :activePage.sync="page" 
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)" />
      </CCardBody>

      <LoadingCover v-show="loading" />

      <CElementCover :opacity="0.75" v-show="processing">
        <div class="text-dark bg-s3skyblue rounded border-dark p-3">
          <h4 class="d-inline mr-2">Procesando...</h4>
          <CSpinner size="sm" color="dark" />
        </div>
      </CElementCover>
    </CCard>

    <!-- Panel sidebar para mostra los articulos de la factura -->
    <RightSideBar size="lg" class="bg-s3grey" :show="showPanelItemsDocument">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader class="bg-s3skyblue">
            <CCardTitle>
              Art&iacute;culos Documento Electr&oacute;nico
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <ElectronicDocumentMovements :electronicDocumentId="electronicDocumentId" :key="updateComponent"/>
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="dark" 
                @click="(e) => {
                  e.stopPropagation();

                  showPanelItemsDocument = false;
                }">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cerrar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <!-- Panel sidebar para capturar archivo de excel y procesarlo -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanel">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Archivo excel DIAN
            </CCardTitle>
            <CCardSubtitle>
              <small>
                Procesamiento archivo excel con registros de documentos DIAN
              </small>
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="fieldsImportExcel" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success" 
                @click="(e) => processImportElectronicDocuments(e)">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Guardar</span>
              </CButton>
              <CButton 
                color="danger" 
                variant="outline" 
                class="ml-2" 
                @click="(e) => {
                  e.stopPropagation();
                  showPanel = false;
                }">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

  </CContainer>
</template>

<!-- <style scoped>
  @import "../../assets/css/table-hover-actions.css";
</style> -->

<script>
  import moment from "moment";

  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import RightSideBar from "../containers/RightSideBar.vue";
  import VerticalDynamicForm from "../containers/VerticalDynamicForm.vue";
  import ElectronicDocumentMovements from "@/components/datagrids/ElectronicDocumentMovements.vue";

  import CONSTANTS from "@/constants";
  import { 
    formatter,
    toBase64
  } from "@/general";
  import { downloadBase64File } from "@/api";
  import { descargaArchivoS3 } from "@/apis/generics";
  import { dataGridDocumentosDian } from "@/apis/electronic-documents";
  import { 
    sendElectronicDocumentEvent, 
    importFileElectronicDocuments,
  } from "@/apiProcess";
  import { 
    saveElectronicDocumentOnPurchaseInvoice 
  } from "@/apis/process";

  const fields = [
    {
      key: "empresa",
      label: "Empresa",
      _style: "text-align:center"
    },
    {
      key: "documento",
      label: "Documento",
      _style: "text-align:center"
    },
    {
      key: 'fechas', 
      label: 'Fechas',
      _style:'text-align:center;'
    },
    {
      key: 'valores', 
      label: 'Valores',
      _style:'text-align:center;'
    },
    {
      key: "acciones",
      label: ""
    }
  ];

  export default {
    name: "ReceptionElectronicDocuments",
    data() {
      return {
        formatter,
        fields,
        loading: false,
        processing: false,
        showPanel: null,
        showPanelItemsDocument: null,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        updateComponent: 0,
        data_documents: [],
        listEventStatus: [],
        electronicDocumentId: "",
        fieldsImportExcel: [
          {
            key: "fileExcel",
            label: "Archivo Excel:",
            value: "",
            type: "file",
            placeholder: "Seleccione archivo excel",
            required: true,
            prepend_content: {
              type: "icon",
              name: "cil-file"
            }
          }
        ],
        eventStatusSelected: "",
        eventStatus: {
          "030": "Acuse de Recibo",
          "031": "Reclamo en documento",
          "032": "Recibo del bien o servicio",
          "033": "Aceptacion Expresa",
          "034": "Aceptacion Tacita",
          "N/D": "No Disponible"
        },
        fileElectronicDocuments: ""
      }
    },
    components: {
      LoadingCover,
      RightSideBar,
      VerticalDynamicForm,
      ElectronicDocumentMovements
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true
        this.page = page
        this.searchWord = search
        
        try {
          const { count, results } = await dataGridDocumentosDian(this, page, search, this.eventStatusSelected)
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.data_documents = results
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "NO se pudo cargar los datos",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async processImportElectronicDocuments(e) {
        e.preventDefault();
        e.stopPropagation();

        this.processing = true;

        try {
          const fileBase64 = await toBase64(this.fieldsImportExcel[0].value).then(file => file);
          const parametros = {
            "Archivo_Base64": fileBase64
          }

          const { errorCode, errorMessage, response } = await importFileElectronicDocuments(this, parametros);

          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: response,
              show: 5
            });
          } else {
            this.$store.commit("setAlert", {
              color: "danger",
              message: errorMessage,
              show: 5
            });
          }
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error al cargar los datos. Error ${error}`,
            show: 5
          })
        } finally {
          this.processing = false;
          this.showPanel = false;
        }
      },
      async sendEvent(e, idDocument, codeEvent) {
        e.stopPropagation();
        e.preventDefault();

        this.processing = true;

        try {
          const dataRequest = {
            "Id_Documento": idDocument,
            "Codigo_Evento": codeEvent,
            "Codigo_Rechazo": null
          };

          const { errorCode, errorMessage } = await sendElectronicDocumentEvent(this, dataRequest);

          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: "Se envio el Evento correctamente.",
              show: 5
            });

            this.getData(this.page, this.searchWord);
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: `Error: ${errorCode} - ${errorMessage}`,
              show: 5
            });
          }
        } catch (error) {
          console.log(error);

          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al grabar los datos",
            show: 5
          });
        } finally {
          this.processing = false;
        }
      },
      async downloadAttachment(e, pathFile) {
        e.stopPropagation();
        e.preventDefault();

        if (pathFile) {
          this.processing = true;

          try {
            const parameters = {
              "F": pathFile,
              "TypeFile": "base64"
            };
  
            const { response } = await descargaArchivoS3(this, parameters);
            const { nombreArchivo, contenidoArchivo } = response;
  
            downloadBase64File("pdf", contenidoArchivo, nombreArchivo);
          } catch (error) {
            console.log(error);

            const { errorCode, errorMessage } = error.data;
  
            this.$store.commit("setAlert", {
              color: "danger",
              message: `NO se pudo descargar el archivo. Error: [${error.status} - ${error.statusText}] Codigo: ${errorCode} Mensaje: ${errorMessage}`,
              show: 5
            });
          } finally {
            this.processing = false;
          }
        } else {
          this.$store.commit("setAlert", {
            color: "warning",
            "message": "El archivo PDF NO esta disponible para descargar.",
            show: 5
          });
        }
      },
      tryConvertElectronicDocument(e, electronicDocumentId) {
        e.preventDefault();
        e.stopPropagation();

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Grabar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "green";

        this.$confirm("¿Confirma que desea grabar este documento electronico en factura de venta?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.convertElectronicDocumentoToPurchaseInvoice(electronicDocumentId);
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
        });
      },
      async convertElectronicDocumentoToPurchaseInvoice(electronicDocumentId) {
        this.processing = true;
        
        try {
          const parameters = {
            "Id_DocumentoDIAN": electronicDocumentId
          };

          const { response } = await saveElectronicDocumentOnPurchaseInvoice(this, parameters);

          console.log(response);
        } catch (error) {
          const { errorCode, errorMessage } = error.data;

          this.$store.commit("setAlert", {
            color: "danger",
            message: `NO se pudo descargar el archivo. Error: [${error.status} - ${error.statusText}] Codigo: ${errorCode} Mensaje: ${errorMessage}`,
            show: 5
          });
        } finally {
          this.processing = false;
        }
      },
      loadEventStatus() {
        this.listEventStatus = [
          {
            "value": "",
            "label": "Todos"
          },
          {
            "value": "000",
            "label": "Sin Evento"
          }
        ]

        Object.keys(this.eventStatus).map((key) => { 
          this.listEventStatus.push(
            {
              "value": key, 
              "label": this.eventStatus[key]
            }
          );
        });
      },
      getBadgeColor(estado) {
        if (estado === null || estado === "") return "info"
        if (estado === "030") return "dark"
        if (estado === "031") return "danger"
        if (estado === "032") return 'warning'
        if (estado === "033") return "success"
        if (estado === "034") return "success"
        if (estado === "N/D") return "secondary"
      }
    },
    mounted() {
      this.loadEventStatus();
      this.getData(this.page);
    }
  }
</script>
